import { render } from "./TourButton.vue?vue&type=template&id=66d6b9d8&scoped=true"
import script from "./TourButton.vue?vue&type=script&lang=js"
export * from "./TourButton.vue?vue&type=script&lang=js"

import "./TourButton.vue?vue&type=style&index=0&id=66d6b9d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d6b9d8"]])

export default __exports__